import { useProject } from '../../../project-hooks/useProject';
import { isActive } from '../../../project-model';
import { ProjectSupportButtonsActive } from './ProjectSupportButtonsActive';

export const ProjectSupportButtonsIfActive = ({ projectShareModalRef, className, promoteActivity }) => {
    const project = useProject();
    const projectIsActive = isActive(project);

    if (projectIsActive) {
        return (
            <ProjectSupportButtonsActive
                projectShareModalRef={projectShareModalRef}
                className={className}
                promoteActivity={promoteActivity}
            />
        );
    }

    return null;
};
